import React from 'react';
import { motion } from 'framer-motion';
import { PerformanceOverview } from './performance/PerformanceOverview';
import { ClientProgressMetrics } from './clients/ClientProgressMetrics';
import { BusinessMetrics } from './business/BusinessMetrics';
import { AnalyticsTabs } from './AnalyticsTabs';

export function TrainerAnalytics() {
  const [activeTab, setActiveTab] = React.useState('overview');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Analytics Dashboard</h1>
      </div>

      <AnalyticsTabs activeTab={activeTab} onTabChange={setActiveTab} />

      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
      >
        {activeTab === 'overview' && <PerformanceOverview />}
        {activeTab === 'clients' && <ClientProgressMetrics />}
        {activeTab === 'business' && <BusinessMetrics />}
      </motion.div>
    </div>
  );
}